import {  Event, NavigationStart, Router } from "@angular/router";
import { NavigationHistoryService } from "../services/navigation-service/navigation-history.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BrowserBackButtonClickedListener {
    constructor(
        private readonly router: Router,
        private readonly navigationHistoryService: NavigationHistoryService
    ) { 
        this.router.events.subscribe(event => {
            this.handleBrowserBackButtonClicked(event);
        });
        
    }
    
    private handleBrowserBackButtonClicked(event: Event) {
        if (this.isBrowserBackButtonClicked(event)) {
            this.handleGoBackFromIntegratorPage();
        }
    }
    
    private isBrowserBackButtonClicked(event: Event): boolean {
        return event instanceof NavigationStart 
            && event.navigationTrigger === 'popstate';
    }
    
    private handleGoBackFromIntegratorPage() {
        /* Condition: 
            The browser's back button is clicked at Integrator page (Edit mode),
            and the last page is Integrator page (Create mode) */
        if (this.router.url.includes('integrator/edit')
            && this.navigationHistoryService.getPreviousPath()?.includes('integrator/create')) {
        
            this.navigationHistoryService.popLastPath();
            this.navigationHistoryService.goBack();
        }
    }
    

    
}